import { numFormat } from '@utils/tool';

export const SubMatter_COLUMNS = [
  {
    title: '产品分类',
    dataIndex: 'productLineName',
    key: 'productLineName'
  },
  {
    title: '标的物',
    dataIndex: 'subjectMatterName',
    key: 'subjectMatterName'
  },
  {
    title: '标的物品牌',
    width: 150,
    dataIndex: 'subjectMatterBrand',
    key: 'subjectMatterBrand'
  },
  {
    title: '标的物型号',
    width: 150,
    dataIndex: 'subjectMatterModel',
    key: 'subjectMatterModel'
  },
  {
    title: '项目是否要求国产',
    width: 150,
    dataIndex: 'importTypeValue',
    key: 'importTypeValue'
  },
  {
    title: '标的物中标单价(万元)',
    dataIndex: 'subjectMatterPrice',
    key: 'subjectMatterPrice',
    render: (record: any) => {
      return record.subjectMatterPrice
        ? numFormat(record.subjectMatterPrice) +
            ' ' +
            (record.subjectMatterCurrencyValue || '')
        : '';
    }
  },
  {
    title: '数量',
    key: 'subjectMatterNumber',
    dataIndex: 'subjectMatterNumber'
  },
  {
    title: '标的物中标总价(万元)',
    key: 'totalAmount',
    dataIndex: 'totalAmount',
    render: (record: any) => {
      return record.totalAmount
        ? numFormat(record.totalAmount) +
            ' ' +
            (record.totalAmountCurrencyValue || '')
        : '';
    }
  },
  // {
  //   title: '预计采购时间',
  //   key: 'estimatedPurchaseTime',
  //   dataIndex: 'estimatedPurchaseTime',
  //   render: (record: any) => {
  //     return record.estimatedPurchaseTime
  //       ? dayjs(record.estimatedPurchaseTime).format(DEFAULT_DATE_FORMAT)
  //       : '';
  //   }
  // },
  {
    title: '中标商',
    key: 'successfulCompany',
    dataIndex: 'successfulCompany'
  }
  // {
  //   title: '主要配置',
  //   width: 150,
  //   key: 'majorDispositions',
  //   dataIndex: 'majorDispositions'
  // }
];
export const ADDSUBJECTMATTER_DETAIL = [
  {
    label: '产品分类',
    required: true,
    type: 'select',
    name: 'productLineKey'
  },
  {
    label: '标的物',
    required: true,
    type: 'input',
    name: 'subjectMatterName'
  },
  {
    label: '标的物品牌',
    required: false,
    type: 'input',
    name: 'subjectMatterBrand'
  },
  {
    label: '标的物型号',
    required: false,
    type: 'input',
    name: 'subjectMatterModel'
  },
  {
    label: '项目是否要求国产',
    required: false,
    type: 'checkbox',
    name: 'importType'
  },
  {
    label: '标的物中标单价(万元)',
    required: false,
    type: 'amount',
    name: 'subjectMatterPrice'
  },
  {
    label: '数量',
    required: false,
    type: 'step',
    name: 'subjectMatterNumber'
  },
  {
    label: '标的物中标总价(万元)',
    required: false,
    type: 'amount',
    name: 'totalAmount'
  },
  // {
  //   label: '预计采购时间',
  //   required: false,
  //   type: 'time',
  //   name: 'estimatedPurchaseTime'
  // },
  {
    label: '中标商',
    required: false,
    type: 'input',
    name: 'successfulCompany'
  }
  // {
  //   label: '主要配置',
  //   required: false,
  //   type: 'input',
  //   name: 'majorDispositions'
  // }
];
